import {
  loadFullFieldMessage,
  loadFullGroupMessage,
  loadFullSchemaMessage,
} from "../fimportal";
import type { FieldImport, GroupImport, SchemaDocument } from "../project";
import {
  createFieldImport as createXdf2FieldImport,
  createGroupImport as createXdf2GroupImport,
  createSchemaDocument as createXdf2SchemaDocument,
} from "./xdf2";

export * as xdf2 from "./xdf2";
export * as xdf3 from "./xdf3";

export async function importSchema(
  fimId: string,
  fimVersion: string,
): Promise<SchemaDocument> {
  const { message, codeLists } = await loadFullSchemaMessage(fimId, fimVersion);
  return createXdf2SchemaDocument(message, codeLists);
}

export async function importField(
  fimId: string,
  fimVersion: string,
): Promise<FieldImport> {
  const { message, codeLists } = await loadFullFieldMessage(fimId, fimVersion);
  return createXdf2FieldImport(message, codeLists);
}

export async function importGroup(
  fimId: string,
  fimVersion: string,
): Promise<GroupImport> {
  const { message, codeLists } = await loadFullGroupMessage(fimId, fimVersion);
  return createXdf2GroupImport(message, codeLists);
}
